<div  class="{{getDirection() =='rtl'?'base-rtl':'base-ltr'}}">
    <div  #center id="center"  class="center"
         [@routeAnimations]="outlet.isActivated ? outlet.activatedRoute : '' && outlet.activatedRouteData
    && outlet.activatedRouteData['animation']">
        <div class="ui-g-12 " spellcheck="false">
            <router-outlet #outlet="outlet"></router-outlet>
        </div>
    </div>
</div>